import { ErrorMessage } from '@helvetia/components/forms/Input/Input.styles'
import { Row } from '@helvetia/components/layout'
import { FieldProps } from 'formik'
import * as React from 'react'

import { QuestionWrapper } from '../_components/common.styles'
import { Terrific } from '../_components/Terrific'

interface Props {
  type: string
  text: string
  label: string
  lang?: string
  maxDate?: number[]
}

const DatePicker: React.SFC<Props & FieldProps<any>> = ({
  field,
  form,
  type,
  text,
  label,
  lang,
  maxDate,
}) => {
  return (
    <>
      <Row marginBottom="xxxs">
        <QuestionWrapper>{text}</QuestionWrapper>
      </Row>
      <Terrific>
        <div
          className="uxc-m-date-picker uxc-m-date-picker--full-width"
          data-pristine="true"
          data-language={lang}
          data-t-name="UXCDatePicker"
          data-max-date={
            maxDate ? `${maxDate[0]},${maxDate[1]},${maxDate[2]}` : ''
          }
        >
          <Terrific>
            <div
              className="uxc-a-date-field uxc-js-a-date-field"
              data-t-name="UXCDateField"
              data-date-format="dd.mm.yyyy"
            >
              <Terrific>
                <label
                  className="uxc-a-text-input uxc-a-text-input--with-label uxc-state-a-text-input--focused uxc-a-text-input--color-gray"
                  data-t-name="UXCInput"
                >
                  <span className="uxc-a-text-input__wrap">
                    <span className="uxc-a-text-input__label">{label}</span>
                    <input
                      className="uxc-a-text-input__input uxc-js-a-text-input__input"
                      type={type}
                      {...field}
                      onBlur={e =>
                        form.setFieldValue(field.name, e.target.value)
                      }
                    />
                  </span>
                  <span className="uxc-a-text-input__children">
                    <span className="uxc-a-text-input__children-content">
                      <a
                        className="uxc-m-date-picker-button uxc-js-m-date-picker-button"
                        href="javascript:;"
                      />
                    </span>
                  </span>
                </label>
              </Terrific>

              <input
                className="uxc-js-a-date-field__hidden "
                type="hidden"
                {...field}
              />
            </div>
          </Terrific>
          <div className="uxc-m-date-picker__pickadate" />
        </div>
      </Terrific>
      {form.touched[field.name] && form.errors[field.name] && (
        <Terrific>
          <ErrorMessage> {form.errors[field.name]}</ErrorMessage>
        </Terrific>
      )}
    </>
  )
}

export default DatePicker
